import React from 'react'
import PropTypes from 'prop-types'

import { Box, Button, Dialog, Typography } from '@material-ui/core'

import useStyles from './styles'

const CancelRegistrationDialog = ({ open, onClose, onConfirm }) => {
  const classes = useStyles()

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      classes={{ paper: classes.paper }}
    >
      <Box className={classes.content}>
        <Typography variant="h6" className={classes.title}>
          Cancelar cadastro de inventário
        </Typography>
        <Typography variant="body2" className={classes.description}>
          Ao confirmar, você voltará para a tela de listagem e perderá o
          histórico de sua conversa com a DAI.
        </Typography>
      </Box>

      <Box className={classes.actions}>
        <Button
          fullWidth
          variant="outlined"
          className={classes.continueButton}
          onClick={onClose}
        >
          Continuar com o cadastro
        </Button>
        <Button
          fullWidth
          variant="outlined"
          className={classes.cancelButton}
          onClick={onConfirm}
        >
          Cancelar cadastro
        </Button>
      </Box>
    </Dialog>
  )
}

CancelRegistrationDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
}

export default CancelRegistrationDialog
